import { useEffect, useState } from 'react';

import palette from '@lib/core/src/theme/palette';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import { Box, Stack, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import { usePatchUserAgentsConfig } from '@/api/generated';
import { useUserAgents } from '@/hooks/useUserAgents';

import { TimingCard } from './AgentDelegateStyles';

const timingList = [
  {
    name: 'After 1 day',
    value: 1
  },
  {
    name: 'After 3 days',
    value: 3
  },
  {
    name: 'After 1 week',
    value: 7
  },
  {
    name: 'After 2 weeks',
    value: 14
  }
];

export const AgentDelegateFollowUp = () => {
  const queryClient = useQueryClient();
  const { data: agents } = useUserAgents();
  const [selectedTimingValue, setSelectedTimingValue] = useState(1);
  const { mutate } = usePatchUserAgentsConfig({
    mutation: {
      onSuccess: async () => await queryClient.invalidateQueries({ queryKey: ['userAgentsConfig'] })
    }
  });
  const timingValue = agents?.items?.at(0)?.taskFollowUp?.daysAfterDelegation ?? 1;

  const onTimingClick = (value: number) => {
    setSelectedTimingValue(value);
    mutate({
      data: {
        taskFollowUp: {
          daysAfterDelegation: value
        }
      }
    });
  };

  useEffect(() => {
    setSelectedTimingValue(timingValue);
  }, [timingValue]);

  return (
    <Box>
      <Typography sx={{ fontSize: '13px', color: palette.black }}>Follow-up Timing</Typography>
      <Typography sx={{ fontSize: '11px', color: palette.grey[500] }}>
        Set the follow-up interval for delegated tasks without responses
      </Typography>
      <Stack marginTop={'8px'} gap={'6px'}>
        {timingList.map(timing => (
          <TimingCard
            onClick={() => onTimingClick(timing.value)}
            key={timing.value}
            isActive={selectedTimingValue === timing.value}
          >
            <DateRangeOutlinedIcon sx={{ fontSize: '17px' }} />
            <Typography sx={{ fontSize: '12px' }}>{timing.name}</Typography>
          </TimingCard>
        ))}
      </Stack>
    </Box>
  );
};
